import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import {
  getBillingDetailsSuccess,
  resendBillingDetailEmailSuccess,
  resendBillingDetailEmailFailure,
  showMessages,
} from '../actions'

import { GET_BILLING_DETAILS, RESEND_BILLING_DETAIL_EMAIL } from '../constants/ActionsTypes'

import { getBillingDetailsApi, resendBillingDetailEmailApi } from '../api/billingDetails'

function* getBillingDetails({ payload }) {
  try {
    const response = yield call(getBillingDetailsApi, payload)
    yield put(getBillingDetailsSuccess(response))
  } catch (error) {
    // handled in interceptor
  }
}

function* resendBillingDetailEmail({ payload }) {
  try {
    yield call(resendBillingDetailEmailApi, payload)
    yield put(resendBillingDetailEmailSuccess())

    yield put(
      showMessages({
        summary: 'Billing detail email resent successfully',
        type: 'success',
      }),
    )
  } catch (error) {
    yield put(resendBillingDetailEmailFailure(error))
  }
}

export function* getBillingDetailsSaga() {
  yield takeEvery(GET_BILLING_DETAILS, getBillingDetails)
}

export function* resendBillingDetailEmailSaga() {
  yield takeEvery(RESEND_BILLING_DETAIL_EMAIL, resendBillingDetailEmail)
}

export default function* rootSaga() {
  yield all([fork(getBillingDetailsSaga), fork(resendBillingDetailEmailSaga)])
}
